import React from "react";
import PropTypes from "prop-types";
import { FaStar } from "react-icons/fa";
import { useHistory } from "react-router-dom"; // useNavigate if React Router v6+
import VideoPreview from "./VideoPreview";

const CourseHeader = ({ course, affiliator = "" }) => {
    const history = useHistory(); // useNavigate() if using React Router v6+

    const handleBuyNow = () => {
        const queryParams = new URLSearchParams({
            service: "Course",
            package: course.title,
            amount: course.price,
        });

        if (affiliator) {
            queryParams.append("affiliator", affiliator);
        }

        history.push(`/order?${queryParams.toString()}`);
    };

    return (
        <div className="container py-5 border-bottom">
            <div className="row align-items-center">
                <div className="col-lg-8 mb-4 mb-lg-0">
                    <h1 className="fw-bold">{course.title}</h1>
                    <div className="d-flex align-items-center gap-3 my-3">
                        <div className="d-flex align-items-center">
                            {[...Array(5)].map((_, index) => (
                                <FaStar
                                    key={index}
                                    className="me-1"
                                    color={index < Math.floor(course.rating) ? "#facc15" : "#e4e5e9"}
                                />
                            ))}
                            <span className="ms-2 text-primary fw-semibold">{course.rating}</span>
                        </div>
                        <span className="">({course.totalStudent} students)</span>
                    </div>
                    <p className="">Created by <strong>{course.author}</strong></p>
                </div>

                <div className="col-lg-4">
                    <VideoPreview image={course.image} videoUrl={course.videoUrl} />
                    <button
                        className="btn-default w-100 mt-3"
                        onClick={handleBuyNow}
                    >
                        Buy Now - ৳{course.price}
                    </button>
                </div>
            </div>
        </div>
    );
};

CourseHeader.propTypes = {
    course: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        videoUrl: PropTypes.string.isRequired,
        rating: PropTypes.number.isRequired,
        totalStudent: PropTypes.number.isRequired,
        author: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
    }).isRequired,
    affiliator: PropTypes.string, // Optional
};

export default CourseHeader;
